export const checkinModalGlobal = {
  header: {
    phone: "Phone",
    accommodation: "Accommodation",
    checkin: "Check-in",
    booking: "Booking",
    notAvailable: "Not available",
    notLinked: "Not linked",
    defaultGuestName: "Guest",
  },
  roles: {
    botStaff: "BOT / STAFF",
    guest: "GUEST",
  },
  media: {
    imageAlt: "Sent image",
    locationReceived: "📍 Location received",
    openInMaps: "Open in Google Maps",
    viewCoordinates: "View coordinates ({lat}, {lng})",
    viewFile: "View file",
    document: "Document",
  },
  dropzone: {
    text: "Drop to attach files",
  },
  failure: {
    notSent: "Not sent",
    notSentDefault: "Not sent",
    reasons: {
      paymentIssue: "payment issue on the WhatsApp account",
      cannotReceive: "the number can't receive WhatsApp",
      downloadFailed: "WhatsApp couldn't download the file",
      templateMissingData: "the template is missing data",
      requirementsNotMet: "the message doesn't meet WhatsApp's requirements",
    },
  },
  mode: {
    ai: "AI",
    manual: "Manual",
    autoReplyBanner: "The agent is replying to this guest automatically.",
  },
  predefined: {
    header: "Predefined replies",
    empty: "No predefined replies found",
  },
  input: {
    attachFile: "Attach file",
    placeholder: "Start with / to pick a predefined reply.",
    removeFile: "Remove file",
  },
  toasts: {
    noBookingLinkedSummary: "No booking linked",
    noBookingLinkedDetail: "There's no booking associated with this conversation",
    errorSummary: "Error",
    userIdError: "Couldn't get the user ID",
    manualModeSummary: "Manual mode enabled",
    aiModeSummary: "AI agent enabled",
    manualModeDetail: "You'll reply to messages manually",
    aiModeDetail: "The bot will reply automatically",
    modeChangeError: "Couldn't change the chat mode",
    reactivateIdError: "Couldn't identify the conversation to reactivate it.",
    successSummary: "Success",
    templateSentOk: "Template sent successfully.",
    templateSentError: "Couldn't send the reactivation template.",
    fileTypeSummary: "File type not allowed",
    fileTypeDetail: "{name} isn't an image or PDF.",
    fileSizeSummary: "File too large",
    fileSizeDetail: "{name} exceeds the 5MB limit.",
    sendError: "Couldn't send the message",
  },
};
